import { BaseDestinationItem } from '@/features/destinations/commons';
import { DestinationConnectionToggle } from '@/features/destinations/commons/DestinationConnectionToggle';
import { DistributionChannelConnector } from '@/models/distributionChannels';
import { FC } from 'react';

type CatalogDestinationItemProps = {
  connector: DistributionChannelConnector;
};

export const CatalogDestinationItem: FC<CatalogDestinationItemProps> = ({ connector }) => {
  return (
    <BaseDestinationItem connector={connector}>
      <DestinationConnectionToggle deauthenticateDisabled={false} connector={connector} />
    </BaseDestinationItem>
  );
};
